const initialState = {
  errors: null,
  isError: true,
  isOpened: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SHOW_ERROR_OVERLAY': {
      const { errors, isError, isOpened } = action.payload;
      return {
        ...state,
        errors,
        isError,
        isOpened
      };
    }
    case 'CLEAR_ERROR_OVERLAY': {
      return {
        ...initialState
      };
    }
    default:
      return state;
  }
};

export default reducer;
